import PostImgComponent from "./PostImgComponent";

export default PostImgComponent;
